import React, {Component} from "react";
import { searchIndex, sendEvent } from "../../util/utils";
import Flatpickr from 'react-flatpickr';
import { Portuguese } from "flatpickr/dist/l10n/pt";
import "flatpickr/dist/themes/airbnb.css";
import Awesomplete from 'awesomplete';
import {PRODUCTION_UNIT_ALIAS, STAGE_SHORT} from '../../constants';
import moment from "moment";
import userService from "../../services/UserService";

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFilter: this.props.hasFilter,
      filters: JSON.parse(JSON.stringify(this.props.filters)),
      examString: "",
    };
    this.setExamFn = this.setExam.bind(this);
  }

  async componentDidMount() {
    this.checkStateFilters();
    this.addEventListeners();
    this.loadExamsAutocomplete();
    this.resetExamFilter('');
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  addEventListeners() {
    document.querySelectorAll(".label-inside .form-control").forEach((e) => {
      if (e.value) e.closest(".label-inside").classList.add("filled");
      e.addEventListener("focusin", () =>
        e.closest(".label-inside").classList.add("focus", "filled")
      );
      e.addEventListener("focusout", () => {
        if (!e.value) e.closest(".label-inside").classList.remove("filled");
        e.closest(".label-inside").classList.remove("focus");
      });
    });

    global.addEventListener(
      "awesomplete-selectcomplete",
      this.setExamFn
    );
  }

  removeEventListeners() {
    document.querySelectorAll(".label-inside .form-control").forEach((e) => {
      if (e.value) e.closest(".label-inside").classList.add("filled");
      e.removeEventListener("focusin", () =>
        e.closest(".label-inside").classList.add("focus", "filled")
      );
      e.removeEventListener("focusout", () => {
        if (!e.value) e.closest(".label-inside").classList.remove("filled");
        e.closest(".label-inside").classList.remove("focus");
      });
    });

    global.removeEventListener(
      "awesomplete-selectcomplete",
      this.setExamFn
    );
  }

  checkStateFilters() {
    if (this.state.filters["EventStage"]) {
      if (this.state.filters["EventStage"].indexOf("RECEBIDO") != -1) {
        document.getElementById("situacaoRecebidos").checked = true;
      }
      if (this.state.filters["EventStage"].indexOf("EM PROCESSAMENTO") != -1) {
        document.getElementById("situacaoProcessando").checked = true;
      }
      if (
        this.state.filters["EventStage"].indexOf("EM ANÁLISE TÉCNICA") != -1
      ) {
        document.getElementById("situacaoConferência").checked = true;
      }
      if (this.state.filters["EventStage"].indexOf("RECOLHIDO") != -1) {
        document.getElementById("situacaoRecolhido").checked = true;
      }
      if (
        this.state.filters["EventStage"].indexOf("RESULTADO LIBERADO") != -1
      ) {
        document.getElementById("situacaoConcluidos").checked = true;
      }
      if (this.state.filters["EventStage"].indexOf("CADASTRADO") != -1) {
        document.getElementById("situacaoCadastrado").checked = true;
      }
      if (this.state.filters["EventStage"].indexOf("RECOLETA") != -1) {
        document.getElementById("situacaoRecoleta").checked = true;
      }
      if (this.state.filters["EventStage"].indexOf("PENDÊNCIA TÉCNICA") != -1) {
        document.getElementById("situacaoPendente").checked = true;
      }
      if (this.state.filters["EventStage"].length === 8) {
        document.getElementById("situacaoTodos").checked = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
      }
    }
  }

  async loadExamsAutocomplete() {
    let input = document.getElementById("inputExame");
    let examsType = await this.props.exams();

    this.setState({ examsType });

    new Awesomplete(input, {
      list: await this.props.exams(),
      filter: function (text, input) {
        return Awesomplete.FILTER_CONTAINS(text, input.match(/[^,]*$/)[0]);
      },
      item: function (text, input) {
        return Awesomplete.ITEM(text, input.match(/[^,]*$/)[0]);
      },
      replace: function (text) {
        var before = this.input.value.match(/^.+,\s*|/)[0];
        this.input.value = before + text + ",";
      },
    });
  }

  setPatient(value) {
    this.state.filters["PatientName"] = value;
    let bool = false;
    if (value !== "" && value != null) {
      this.state.hasFilter = true;
      document.getElementById("inputPedido").disabled = true;
    } else {
      document.getElementById("inputPedido").disabled = false;
      delete this.state.filters["PatientName"];
      searchIndex.filter((f) => {
        if (
          this.state.filters[f] !== null ||
          (this.state.filters[f] === [] && f.length > 0)
        ) {
          bool = true;
        }
      });
      this.state.hasFilter = bool;
    }
    this.setState(this.state);
  }
  setOrder(value) {
    this.state.filters["OrderId"] = value;

    let patientInput = document.getElementById("inputPaciente");
    let bool = false;
    if (value !== "" && value != null) {
      this.state.hasFilter = true;
      if(patientInput){
        patientInput.disabled = true;
      }
    } else {
      if(patientInput){
        patientInput.disabled = false;
      }
      delete this.state.filters["OrderId"];
      searchIndex.filter((f) => {
        if (
          this.state.filters[f] !== null ||
          (this.state.filters[f] === [] && f.length > 0)
        ) {
          bool = true;
        }
      });
      this.state.hasFilter = bool;
    }
    this.setState(this.state);
  }

  setDateBegin() {
    let value = document.getElementById("inputDateStart").value;
    let bool = false;
    if (value !== "" && value != null) {
      let dateEnd = this.state.filters["EstimatedResultDate"]?.end ? this.state.filters["EstimatedResultDate"]["end"] : null
      this.state.filters["EstimatedResultDate"] = {begin: value, end: dateEnd};
      if(dateEnd) this.state.hasFilter = true;
    } else {
      delete this.state.filters["EstimatedResultDate"]['begin'];
      searchIndex.filter((f) => {
        if (
          this.state.filters[f] !== null ||
          (this.state.filters[f] === [] && f.length > 0)
        ) {
          bool = true;
        }
      });
      this.state.hasFilter = bool;
    }
    this.setState(this.state);
  }
  setDateEnd() {
    let value = document.getElementById("inputDateEnd").value;
    let bool = false;
    if (value !== "" && value != null) {
      let dateBegin = this.state.filters["EstimatedResultDate"]?.begin ? this.state.filters["EstimatedResultDate"]["begin"] : null
      this.state.filters["EstimatedResultDate"] = {begin: dateBegin, end: value};
      if(dateBegin) this.state.hasFilter = true;
    } else {
      delete this.state.filters["EstimatedResultDate"]['end'];
      searchIndex.filter((f) => {
        if (
          this.state.filters[f] !== null ||
          (this.state.filters[f] === [] && f.length > 0)
        ) {
          bool = true;
        }
      });
      this.state.hasFilter = bool;
    }
    this.setState(this.state);
  }

  setPriority() {
    if (document.getElementById("prioridadeUrgentes").checked === true) {
      this.state.hasFilter = true;
      this.state.filters["Urgency"] = "Urgencias";
    } else {
      delete this.state.filters["Urgency"];
      this.state.hasFilter = this.checkFilters();
    }

    this.setState(this.state);
  }

  setSituation(id) {
    if (id === 0) {
      if (document.getElementById("situacaoTodos").checked === true) {
        this.state.filters["EventStage"] = [
          "RECEBIDO",
          "CADASTRADO",
          "EM PROCESSAMENTO",
          "EM ANÁLISE TÉCNICA",
          "RESULTADO LIBERADO",
          "RECOLHIDO",
          "RECOLETA",
          "PENDÊNCIA TÉCNICA"
        ];

        document.getElementById("situacaoRecebidos").checked = true;
        document.getElementById("situacaoProcessando").checked = true;
        document.getElementById("situacaoConferência").checked = true;
        document.getElementById("situacaoRecolhido").checked = true;
        document.getElementById("situacaoConcluidos").checked = true;
        document.getElementById("situacaoCadastrado").checked = true;
        document.getElementById("situacaoPendente").checked = true;
        document.getElementById("situacaoRecoleta").checked = true;
        this.state.hasFilter = true;
      } else {
        this.state.filters["EventStage"] = [];
        document.getElementById("situacaoRecebidos").checked = false;
        document.getElementById("situacaoProcessando").checked = false;
        document.getElementById("situacaoConferência").checked = false;
        document.getElementById("situacaoRecolhido").checked = false;
        document.getElementById("situacaoConcluidos").checked = false;
        document.getElementById("situacaoCadastrado").checked = false;
        document.getElementById("situacaoPendente").checked = false;
        document.getElementById("situacaoRecoleta").checked = false;
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 1) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoRecebidos").checked === true) {
        this.state.filters["EventStage"].push("RECEBIDO");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index = this.state.filters["EventStage"].indexOf("RECEBIDO");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 2) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoProcessando").checked === true) {
        this.state.filters["EventStage"].push("EM PROCESSAMENTO");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index =
          this.state.filters["EventStage"].indexOf("EM PROCESSAMENTO");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 3) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoConferência").checked === true) {
        this.state.filters["EventStage"].push("EM ANÁLISE TÉCNICA");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index =
          this.state.filters["EventStage"].indexOf("EM ANÁLISE TÉCNICA");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 4) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoConcluidos").checked === true) {
        this.state.filters["EventStage"].push("RESULTADO LIBERADO");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index =
          this.state.filters["EventStage"].indexOf("RESULTADO LIBERADO");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 5) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoRecolhido").checked === true) {
        this.state.filters["EventStage"].push("RECOLHIDO");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index = this.state.filters["EventStage"].indexOf("RECOLHIDO");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 6) {
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoCadastrado").checked === true) {
        this.state.filters["EventStage"].push("CADASTRADO");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index = this.state.filters["EventStage"].indexOf("CADASTRADO");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    } else if (id === 7){
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoPendente").checked === true) {
        this.state.filters["EventStage"].push("PENDÊNCIA TÉCNICA");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index = this.state.filters["EventStage"].indexOf("PENDÊNCIA TÉCNICA");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    }else if (id === 8){
      if (!this.state.filters["EventStage"]) {
        this.state.filters["EventStage"] = [];
      }
      if (document.getElementById("situacaoRecoleta").checked === true) {
        this.state.filters["EventStage"].push("RECOLETA");
        this.state.hasFilter = true;
      } else {
        document.getElementById("situacaoTodos").checked = false;
        let index = this.state.filters["EventStage"].indexOf("RECOLETA");
        this.state.filters["EventStage"].splice(index, 1);
        if (this.state.filters["EventStage"].length === 0) {
          delete this.state.filters["EventStage"];
        }
        this.state.hasFilter = this.checkFilters();
      }
    }
    this.setState(this.state);
  }

  setExam(value) {
    let valueByTyping = value && !value.text && value;
    let valueBySelecting = value && value.text && value.text.value;

    if ((valueByTyping || valueByTyping === "") && valueByTyping !== null) {
      if (valueByTyping === "") {
        delete this.state.filters.Exam;
        this.setState(this.state);
        this.setState({ examString: value });
      } else if (valueByTyping && valueByTyping.includes(",")) {
        let clearedFilters = this.clearNonValidExamsFilter(valueByTyping);
        this.resetExamFilter(clearedFilters || "");
      } else {
        this.setState({ examString: value });
      }
    }

    if (valueBySelecting) {
      this.setExamOption(value.text.value);
    }
    this.setState({ hasFilter: this.checkFilters() });
  }

  setExamOption(examOption) {
    let isExamOptionSet = this.checkIfExamOptionIsSet(examOption);
    let isExamFilterOnLimit =
      this.state.filters &&
      this.state.filters.Exam && 
      this.state.filters.Exam.length === 5;
    if (isExamFilterOnLimit) {
      this.showDialogErrorMessage(
        "Filtro não permitido",
        "Apenas 5 tipos de exames são permitidos por consulta."
      );
      this.resetExamFilter();
    } else if (!isExamOptionSet) {
      if (this.state.filters.Exam && this.state.filters.Exam.length !== null) {
        this.state.filters.Exam.push(examOption);
        this.setState(this.state);
      } else {
        this.state.filters.Exam = [];
        this.state.filters.Exam.push(examOption);
        this.setState(this.state);
      }
      this.resetExamFilter();
    } else {
      this.resetExamFilter();
    }
  }

  resetExamFilter(value) {
    let examFilterHtmlElement = document.getElementById("inputExame");

    if (examFilterHtmlElement) {
      value =
        value ||
        (this.state.filters.Exam && this.state.filters.Exam.length !== 0
          ? this.state.filters.Exam.join(",") + ","
          : "");
    }
    this.setState({ examString: value });
    examFilterHtmlElement.value = value;
    if(value){
      examFilterHtmlElement &&
      examFilterHtmlElement.parentElement && 
      examFilterHtmlElement.parentElement.classList.add('filled')
    }
  }

  resetLocalFilters() {}

  checkIfExamOptionIsSet(examOption) {
    if (
      this.state.filters.Exam &&
      this.state.filters.Exam.length &&
      this.state.filters.Exam.length > 0
    ) {
      if (this.state.filters.Exam.contains(examOption)) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  clearNonValidExamsFilter(examFilters) {
    if (examFilters && examFilters.split) {
      let splittedExamFilters = examFilters.split(",");
      let clearExamFilter = [];
      let userIncompleteTyping = null;

      for (let splittedExamFilter of splittedExamFilters) {
        if (
          this.state.examsType &&
          this.state.examsType.contains &&
          this.state.examsType.contains(splittedExamFilter)
        ) {
          clearExamFilter.push(splittedExamFilter);
        }
      }

      clearExamFilter.length === 0
        ? delete this.state.filters.Exam
        : (this.state.filters.Exam = clearExamFilter);
      this.setState(this.state);

      if (splittedExamFilters && splittedExamFilters.length > 0) {
        userIncompleteTyping = !this.state.examsType.contains(
          splittedExamFilters[splittedExamFilters.length - 1]
        )
          ? splittedExamFilters[splittedExamFilters.length - 1]
          : "";
      }

      return clearExamFilter.length === 0
        ? ""
        : clearExamFilter.join() + "," + userIncompleteTyping.trim();
    } else {
      return null;
    }
  }

  mountDateFilter(){
    if(this.state.filters['EstimatedResultDate']?.begin && this.state.filters['EstimatedResultDate']?.end){
      return `De ${this.state.filters['EstimatedResultDate']['begin']} Até ${this.state.filters['EstimatedResultDate']['end']}`;
    }
    return false;
  }

  mapFilters(array) {
    const FILTERS_COMPLETE = {
      OrderId: "Pedido: ",
      ProductionUnitName: "Unidade: ",
      PatientName: "Paciente: "
    };
    const URGENCY = {
      Urgency: "Urgentes",
    };
    let filters = [];
    array.forEach((element) => {
      if (this.state.filters[element] != null) {
        if (this.state.filters[element] instanceof Array) {
          this.state.filters[element].forEach((value) => {
            filters.push(
              <div className="label-tag">
                {STAGE_SHORT[value] || value}
                <div
                  className="remove-label-tag"
                  onClick={() => {
                    this.clearFilter(element, value);
                  }}
                >
                  x
                </div>
              </div>
            );
          });
        } else if(element !== 'EstimatedResultDate'){
          filters.push(
            <div className="label-tag">
              {
                this.state.filters[element] && FILTERS_COMPLETE[element] &&
                 PRODUCTION_UNIT_ALIAS[this.state.filters[element]] ?
                 FILTERS_COMPLETE[element] + PRODUCTION_UNIT_ALIAS[this.state.filters[element]] :           
                  FILTERS_COMPLETE[element]
                    ? FILTERS_COMPLETE[element] + this.state.filters[element]
                    : URGENCY[element] || this.state.filters[element]
              }
              <div
                className="remove-label-tag"
                onClick={() => {
                  this.clearFilter(element);
                }}
              >
                x
              </div>
            </div>
          );
        }else{
          let labelDataFilter = this.mountDateFilter();
          if(labelDataFilter){
            filters.push(
              <div className="label-tag">
                {labelDataFilter}
                <div className="remove-label-tag"
                onClick={()=>  this.clearFilter(element)}
                >x</div>
              </div>
            )
          }
        }
      }
    });
    return filters;
  }

  clearFilter(element, value = null) {
    const STATUS_ID = {
      CADASTRADO: "situacaoCadastrado",
      "EM ANÁLISE TÉCNICA": "situacaoConferência",
      "EM PROCESSAMENTO": "situacaoProcessando",
      RECEBIDO: "situacaoRecebidos",
      RECOLHIDO: "situacaoRecolhido",
      "RESULTADO LIBERADO": "situacaoConcluidos",
      "PENDÊNCIA TÉCNICA": "situacaoPendente",
      "RECOLETA": 'situacaoRecoleta'
    };

    if (value) {
      let array = this.state.filters[element];
      let index = array.indexOf(value);
      array.splice(index, 1);
      if (array.length === 0) {
        delete this.state.filters[element];
      } else {
        this.state.filters[element] = array;
      }
      if (element === "EventStage") {
        document.getElementById(STATUS_ID[value]).checked = false;
      }
    } else {
      let filters = this.state.filters;
      delete filters[element];
      this.clearField(element);
      this.state.filters = filters;
    }
    this.state.hasFilter = this.checkFilters();
    this.setState(this.state);
    this.resetExamFilter();
  }

  checkFilters() {
    let hasFilter = false;
    if (this.state.filters) {
      for (let c = 0; c < searchIndex.length; c++) {
        hasFilter =
          (this.state.filters[searchIndex[c]] != null &&
            !(this.state.filters[searchIndex[c]] instanceof Array)) ||
          (this.state.filters[searchIndex[c]] instanceof Array &&
            this.state.filters[searchIndex[c]].length > 0);
        if (hasFilter) {
          c = searchIndex.length;
        }
      }
    }
    return hasFilter;
  }

  showDialogErrorMessage(title, errorMessage) {
    if (title && errorMessage) {
      let dialog = {
        type: "Error",
        title: title,
        message: errorMessage,
        show: true,
        confirmation: () => {
          sendEvent("show-dialog", { show: false });
        },
      };
      sendEvent("show-dialog", dialog);
    }
  }
  clearField(field) {
    const FIELDS = {
      PatientName: "inputPaciente",
      OrderId: "inputPedido",
      Exam: "inputExame",
    };

    if (field === "Urgency") {
      document.getElementById("prioridadeUrgentes").checked = false;
    } else if (!field.includes("Date")) {
      document.getElementById(FIELDS[field]).value = null;
    } else if (field === "EstimatedResultDateBegin") {
      const fp = document.querySelector("#inputDateStart")._flatpickr;
      fp.clear();
      document
        .querySelector("#inputDateStart")
        .closest(".label-inside")
        .classList.remove("filled");
      document
        .querySelector("#inputDateStart")
        .closest(".label-inside")
        .classList.remove("focus");
    } else if (field === "EstimatedResultDateEnd") {
      const fp = document.querySelector("#inputDateEnd")._flatpickr;
      fp.clear();
      document
        .querySelector("#inputDateEnd")
        .closest(".label-inside")
        .classList.remove("filled");
      document
        .querySelector("#inputDateEnd")
        .closest(".label-inside")
        .classList.remove("focus");
    }
  }

  verifyFilters() {
    if (
      this.state.filters["EstimatedResultDate"] &&
      this.state.filters["EstimatedResultDate"]?.begin &&
      this.state.filters["EstimatedResultDate"]?.end
    ) {
      if (
        moment(
          moment(
            this.state.filters["EstimatedResultDate"]?.end,
            "DD/MM/YY"
          ).format("YYYY-MM-DD")
        ).isSameOrAfter(
          moment(
            moment(
              this.state.filters["EstimatedResultDate"]?.begin,
              "DD/MM/YY"
            ).format("YYYY-MM-DD")
          )
        )
      ) {
        this.props.submit(this.state.filters, this.state.hasFilter);
      } else {
        this.showDialogErrorMessage(
          "Erro na Filtragem",
          "A data de início não pode ser maior que a data de fim"
        );
      }
    } else if (
      this.state.filters["EstimatedResultDate"]?.begin ||
      this.state.filters["EstimatedResultDate"]?.end
    ) {
      this.showDialogErrorMessage(
        "Erro na Filtragem",
        "Ambas as datas devem ser preenchidas"
      );
    }  else {
      this.props.submit(this.state.filters, this.state.hasFilter);
    }
  }

  render() {
    return (
      <>
        <div
          className="bt-close"
          onClick={() => {
            this.props.close();
          }}
        >
          x
        </div>
        <div className="fieldset">
          {userService.getUserType() !== "PSC" ? (
            <div
              className="form-group label-inside"
              style={{ marginTop: "10px" }}
            >
              <label
                htmlFor="inputPaciente"
                id="labelPaciente"
                className="form-label"
              >
                Paciente
              </label>
              <input
                value={
                  this.state.filters["PatientName"]
                    ? this.state.filters["PatientName"]
                    : null
                }
                data-bs-toggle="tooltip" 
                title={
                  this.state.filters["OrderId"] && 
                  "Não é possível filtrar por pedido e paciente simultaneamente"
                } 
                disabled={this.state.filters["OrderId"]}
                type="text"
                className="form-control"
                id="inputPaciente"
                onChange={(e) => {
                  this.setPatient(e.currentTarget.value);
                }}
              />
            </div>
          ) : null}
          <div className="form-group label-inside">
            <label
              htmlFor="inputPedido"
              id="labelPedido"
              className="form-label"
            >
              Pedido
            </label>
            <input
              value={
                this.state.filters["OrderId"]
                  ? this.state.filters["OrderId"]
                  : null
              }
              data-bs-toggle="tooltip" 
              title={
                this.state.filters["PatientName"] && 
                "Não é possível filtrar por pedido e paciente simultaneamente"
              } 
              disabled={this.state.filters["PatientName"]}
              type="text"
              className="form-control"
              id="inputPedido"
              onChange={(e) => {
                this.setOrder(e.currentTarget.value);
              }}
            />
          </div>
          <div className="form-group label-inside mb-0">
            <label htmlFor="inputExame" id="labelExame" className="form-label">
              Exame
            </label>
            <input
              value={
                this.state.examString 
                ? this.state.examString 
                : null
              }
              type="text"
              className="form-control"
              id="inputExame"
              data-multiple
              onChange={(e) => {
                this.setExam(e.currentTarget.value);
              }}
            />
          </div>
        </div>
        <div className="fieldset">
          <h3 className="fieldset-title">Previsão de resultado</h3>
          <div className="row row-gutter-20">
            <div className="col-6">
              <div className="form-group label-inside form-group-ico-right ico-calendar">
                <label
                  htmlFor="inputDateStart"
                  id="labelDateStart"
                  className="form-label"
                >
                  De
                </label>
                <Flatpickr
                  value={
                    this.state.filters["EstimatedResultDate"]&&
                    this.state.filters["EstimatedResultDate"]['begin']
                      ? this.state.filters["EstimatedResultDate"]["begin"]
                      : null
                  }
                  id="inputDateStart"
                  className="form-control"
                  options={{
                    allowInput: false,
                    locale: { ...Portuguese },
                    dateFormat: "d/m/y",
                  }}
                  onChange={(value) => {
                    this.setDateBegin(value);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group label-inside form-group-ico-right ico-calendar">
                <label
                  htmlFor="inputDateEnd"
                  id="labelDateEnd"
                  className="form-label"
                >
                  Até
                </label>
                <Flatpickr
                  value={
                    this.state.filters["EstimatedResultDate"] &&
                    this.state.filters["EstimatedResultDate"]["end"] 
                      ? this.state.filters["EstimatedResultDate"]["end"]
                      : null
                  }
                  id="inputDateEnd"
                  className="form-control"
                  options={{
                    allowInput: false,
                    locale: { ...Portuguese },
                    dateFormat: "d/m/y",
                  }}
                  onChange={(value) => {
                    this.setDateEnd(value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="fieldset">
          <h3 className="fieldset-title">Prioridades</h3>
          <div className="row">
            <div className="col-6">
              <div className="form-check">
                <input
                  checked={this.state.filters["Urgency"]}
                  className="form-check-input"
                  type="checkbox"
                  id="prioridadeUrgentes"
                  onClick={() => {
                    this.setPriority(1);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="prioridadeUrgentes"
                >
                  Urgentes
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="fieldset" id="situationList">
          <h3 className="fieldset-title">Situação</h3>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="situacaoTodos"
              onClick={() => {
                this.setSituation(0);
              }}
            />
            <label className="form-check-label" htmlFor="situacaoTodos">
              Todos
            </label>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoCadastrado"
                  onClick={() => {
                    this.setSituation(6);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoCadastrado"
                >
                  Cadastrado
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoRecebidos"
                  onClick={() => {
                    this.setSituation(1);
                  }}
                />
                <label className="form-check-label" htmlFor="situacaoRecebidos">
                  Recebido
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoRecolhido"
                  onClick={() => {
                    this.setSituation(5);
                  }}
                />
                <label class="form-check-label" for="situacaoRecolhido">
                  Recolhido
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoProcessando"
                  onClick={() => {
                    this.setSituation(2);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoProcessando"
                >
                  Em Processamento
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoConferência"
                  onClick={() => {
                    this.setSituation(3);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoConferência"
                >
                  Análise Técnica
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoConcluidos"
                  onClick={() => {
                    this.setSituation(4);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoConcluidos"
                >
                  Liberado
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoPendente"
                  onClick={() => {
                    this.setSituation(7);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoPendente"
                >
                  Pendente
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="situacaoRecoleta"
                  onClick={() => {
                    this.setSituation(8);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="situacaoRecoleta"
                >
                  Recoleta
                </label>
              </div>
            </div>
          </div>
        </div>
        {this.state.hasFilter ? (
          <div className="label-container">{this.mapFilters(searchIndex)}</div>
        ) : null}

        <button
          style={!this.state.hasFilter ? { marginTop: "15px" } : null}
          type="submit"
          className="bt bt-ico-filter"
          onClick={() => {
            this.resetExamFilter();
            this.verifyFilters();
          }}
        >
          Buscar
        </button>
      </>
    );
  }
}

export default Filters;
